import React from "react";
var MenuMixin = require("../ui_elements/menu").MenuMixin;
var Isvg = require("../../../vendor/react-inlinesvg");
var Tree = require("../ui_elements/tree");

class CollectionsMenu extends React.Component {
  constructor(props) {
    super(props);
    // TODO: Is this even working correctly?
    // eslint-disable-next-line no-sequences
    this.state = ({ collections: false }, { arrowText: false });

    // Callback bindings
    this._escapeKey = this._escapeKey.bind(this);
    this._windowResize = this._windowResize.bind(this);
    this._removeCollectionsFilter = this._removeCollectionsFilter.bind(this);
    this._hideCollections = this._hideCollections.bind(this);
    this._allBooksfilter = this._allBooksfilter.bind(this);
  }

  _escapeKey(e) {
    if (e.keyCode === 27) {
      if (this.props.isCollectionsOpen) {
        this._hideCollections();
        document.getElementById("folder-view").focus();
      }
    }
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    if (newProps.isCollectionsOpen && !this.state.isCollectionsOpen) {
      this.loadCollectionsData();
    }
  }

  componentDidMount() {
    $(window).on("keyup", this._escapeKey);
    Fraction.Helpers.getUser(
      function(user) {
        this.forceUpdate();
      }.bind(this)
    );
    window.addEventListener("resize", this._windowResize);
    this._scrollCollectionsMenu();
  }

  loadCollectionsData() {
    if (!this.state.collections) {
      this.setState({ collections: [] });
      Fraction.Helpers.addLoader(
        ".slider-menu",
        "top:54px;background:#DADADA;",
        i18n.t("collections.loading-collections")
      );
      Jigsaw.getCollections(
        function(response) {
          if (response.isSuccess()) {
            Fraction.Helpers.removeLoader(".slider-menu");
            this.setState({
              collections: this._addCollectionCallbacks(response.data)
            });
          }
        }.bind(this)
      );
    }
  }

  _scrollCollectionsMenu() {
    var collectionsMenuHeight = $(window).height();
    var collectionHeaderHeight = $(".menuHeaderContainer").height();
    var collectionsScroll =
      collectionsMenuHeight - collectionHeaderHeight - 125;
    $("ul.slider-list-container.parent li:nth-child(2)").css({
      height: collectionsScroll + "px",
      "overflow-y": "auto"
    });
  }

  _addCollectionCallbacks(collections) {
    var i;
    for (i = 0; i < collections.length; i++) {
      var currCollection = collections[i];
      const books = currCollection.books;
      currCollection.count = books.length;
      const title = currCollection.title;
      currCollection.callback = e => {
        var dataLoc = $(e.currentTarget)
          .parent()
          .data("locator");
        this.props.filterByCollection(
          books,
          title,
          (dataLoc + "").split(".").length
        );
        this.setState({ selectedLoc: dataLoc });
        MenuMixin._removeMenu();
      };
      if (currCollection.children.length > 0) {
        this._addCollectionCallbacks(currCollection.children);
      }
    }
    return collections;
  }

  _collectionsLibraryView(e) {
    var dataLoc = $(e.currentTarget)
      .parent()
      .data("locator");
    var currCollection = this._findingNemo(
      this.state.collections,
      this._bulidLocArray(dataLoc)
    );
    this.props.filterByCollection(currCollection.books, currCollection.title);
    this.setState({ selectedLoc: dataLoc });
    MenuMixin._removeMenu();
  }

  _removeCollectionsFilter(e) {
    this.props.filterByCollection(false, "all_books");
    this.setState({ selectedLoc: undefined });
    this._hideCollections();
  }

  _allBooksfilter(e) {
    this.props.filterByCollection(false, "all_books");
    this.setState({ selectedLoc: undefined });
    MenuMixin._removeMenu();
  }

  _hideCollections(e) {
    this.props.openCollections();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this._windowResize);
    $(window).unbind("keyup", this._escapeKey);
  }

  _windowResize(e) {
    this._scrollCollectionsMenu();
  }

  render() {
    var collectionsMenuList = "";
    var collectionsAriaPressed = "";
    var collectionsMenuHeader = (
      <div className="menuHeaderContainer">
        <button
          className="noButton close-collections-menu"
          onClick={this._removeCollectionsFilter}
        >
          <Isvg src="/img/mobile_x.svg" />
          <span className="offScreen">{i18n.t("base.close")}</span>
        </button>
        <h2 id="collectionsMenuHeader" tabIndex={-1}>
          {i18n.t("collections.collections")}
        </h2>
        <button
          className="noButton apply-collections-mobile"
          onClick={this._hideCollections}
        >
          {i18n.t("base.apply")}
        </button>
      </div>
    );
    var collectionsMenuHidden = "true";
    var collectionsMenuOpen = "";

    if (this.props.isCollectionsOpen) {
      collectionsMenuOpen += " collections-menu-open open-menu-content";
      collectionsMenuHidden = "false";
    } else {
      collectionsMenuOpen += " closed-menu-animation";
      collectionsAriaPressed = "true";
    }

    collectionsMenuList = (
      <div
        className={
          "collections-menu slider-menu menu-hidden" + collectionsMenuOpen
        }
        aria-hidden={collectionsMenuHidden}
      >
        {collectionsMenuHeader}
        <div className="slider-list-container parent">
          <div
            name="my-library-button"
            className={
              this.state.selectedLoc !== undefined ? "" : " slider-selected"
            }
          >
            <button className={"noButton"} onClick={this._allBooksfilter}>
              {i18n.t("collections.my-library")}
            </button>
          </div>
          <Tree
            data={this.state.collections}
            selectedLoc={this.state.selectedLoc}
          />
        </div>
      </div>
    );

    return collectionsMenuList;
  }
}

export { CollectionsMenu };
